import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
  Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import Loader from './../../shared/loader'
import download from 'downloadjs'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import Pagination from './../../shared/pagination'
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  name: 'expiryreport',
  components: {
    Paginate,
    DatePicker,
    Pagination,
    download,
    JsonExcel,
    Loader,
  },
  data: function() {
    return {
      // totalRows:0,
      // currentPage: 0,
      show: false,
      download: true,
      csvFieldsForXls: {},
      listReportDataforxls: [],
      resultCount: 0,
      searchFlag: false,
      useremail: '',
      productid: '',
      fromdate: '',
      todate: '',
      reportname: '',
      listExpiryData: [],
      listExpiryDataCsv: [],

      listClientData: [],
      listWarehouseData: [],
      // pageno: 0,
      // totalPage: 0,
      // pageLimit: 10,
      totalPage: 0,
      totalRows: 0,
      currentPage: 1,
      pageLimit: 10,
      client: '',
      clientid: '',
      warehouse: '',
      warehouseid: '',
      showSelectClient: false,
      showSelectWarehouse: false,
      ClientErr: '',
      WarehouseErr: '',

      csvFields: '',
      listTransporterData: [],
      isLoading: false,
      isLoadingData: false,
      formattedDate: '',
      userid: '',
      orderExpiryDays: '',
      days: '',
      clientproductid: '',
      RackType: '',
      dataFilter2: '',
      isLoadingforxls: false,
      limitExeed: false,
      recordLimit: 0,
      only_expired:false,
      hideSelectDays:false
    }
  },

  created: function() {},
  computed: {},

  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.useremail = userdetail.email;
    this.userid = userdetail.userid;
    this.user_type = userdetail.utype;
    //this.getTransporterList();
    this.reportname =  this.$t('editedjson.productExpiryReport')
    this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
    var today = new Date();
    this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss');
    this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
    //console.log(this.formattedDate);

    switch (this.user_type) {
      case 'system_user':
        this.showSelectClient = true;
        this.showSelectWarehouse = true;
        // this.getClientList();
        // this.getWarehouseList();
        break;

      case 'client_user':
        this.clientid = userdetail.clientid;
        // this.getWarehouseList();
        this.showSelectWarehouse = true;
        break;

      case 'warehouse_user':
        this.loginUserEmail = userdetail.email;
        this.warehouseid = userdetail.warehouseid;
        this.showSelectClient = true;
        // this.getClientList();

        var roleids = userdetail.roleid.split(',');
        for (var i = 0; i < roleids.length; i++) {
          if (roleids[i] == 40) {
            this.purchasingManager = parseInt(roleids[i]);
          }
          if (roleids[i] == 41) {
            this.isInwardUserForPO = true;
          }
        }
        break;

      default:
        this.$alertify.error("Unauthorised user, Please contact your system admin");
        break
    } //END SWITCH

this.getRecordLimit()
  },
  methods: {
    onlyExpiredproduct(ev) {
      this.only_expired = document.getElementById("only_expired").checked
      this.hideSelectDays=this.hideSelectDays==true?  false : true
      if(this.hideSelectDays==true){
        this.todate = '';
        this.fromdate = '';
        this.days=''
         }
		},
    getRecordLimit() {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.input = ({

      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getRecordLimit',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data) {
            this.recordLimit = result.data.data;


          }
        }, error => {
          console.error(error)
        })
    },
    startDownload(){
    this.isLoadingforxls =true;
    },
    finishDownload(){
    this.isLoadingforxls =false;
    },
    Choosetype() {
      this.show = true;
      this.download = false;
      if (!this.limitExeed) {
        this.getExpiryDataForXls(3)
      }
    },
    dateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD HH:mm:ss');
    },
    payloaddateFormat(date) {
      if (!date) return '';
      return moment(date).format('YYYY-MM-DD');
    },
    calldateFunction: function() {

      this.todate = '';
      this.fromdate = '';
      if(this.days!=''){
      var cdays = this.days;
      this.currentDate = moment().format('YYYY-MM-DD');
      this.fromdate = this.currentDate;
      var someDate = moment().add(cdays, 'd').format('YYYY-MM-DD');
      this.todate = someDate;
      }
    },

    export (data, filename, mime) {
      let blob = this.base64ToBlob(data, mime)
      download(blob, filename, mime)
    },
    base64ToBlob(data, mime) {
      let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
      let bstr = atob(base64)
      let n = bstr.length
      let u8arr = new Uint8ClampedArray(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], {
        type: mime
      })
    },

    // getWarehouseList() {
    //   this.pageno = 0;
    //   if (window.localStorage.getItem("warehouseList") !== null) {
    //     var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
    //     var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
    //     var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
    //     this.listWarehouseData = JSON.parse(plaintextwarehouse);
    //   } else {

    //     var userToken = window.localStorage.getItem('userToken')
    //     var myStr = userToken.replace(/"/g, '');
    //     this.input = ({
    //       clientid: this.clientid,
    //     });

    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr
    //         }
    //       })
    //       .then(result => {
    //         this.listWarehouseData = result.data.data;
    //       }, error => {
    //         console.error(error)
    //       })
    //   }
    // },

    // getClientList() {
    //   this.pageno = 0;

    //   if (window.localStorage.getItem("clientList") !== null) {
    //     var clientListEncrypt = window.localStorage.getItem('clientList');
    //     var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
    //     var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
    //     this.listClientData = JSON.parse(plaintextclient);
    //   } else {
    //     var userToken = window.localStorage.getItem('userToken');
    //     var myStr = userToken.replace(/"/g, '');
    //     this.input = ({
    //       warehouseid: this.warehouseid,
    //     });

    //     axios({
    //         method: 'POST',
    //         'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
    //         'data': this.input,
    //         headers: {
    //           'Authorization': 'Bearer ' + myStr,
    //         }
    //       })
    //       .then(result => {
    //         this.listClientData = result.data.data;
    //       }, error => {
    //         console.error(error);
    //       });
    //   }
    // },

    // clientSelected() {
    //   if (this.clientid != this.client) {
    //     this.clientid = this.client;
    //     this.pageno = 0;
    //     this.totalPage = 0;
    //     this.currentPage = 1
    //     this.resultCount = 0;
    //     this.listRTOData = [];
    //     this.getWarehouseList();
    //     if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
    //       this.warehouse = this.warehouseid = '';
    //     }
    //   }

    //   this.clientid = this.client;
    //   if (this.clientid) {
    //     if (this.warehouseid == '') {
    //       this.getWarehouseList();
    //     }
    //   }
    // },

    // warehouseSelected() {
    //   if (this.warehouseid != this.warehouse) {
    //     this.listRTOData = [];
    //     this.pageno = 0;
    //     this.currentPage = 1
    //     this.totalPage = 0;
    //     this.resultCount = 0;
    //   }
    //   this.warehouseid = this.warehouse;
    //   if (this.warehouseid) {
    //     if (this.clientid == '') {
    //       this.getClientList();
    //     }
    //   }
    // },

    getExpiryListSearchData() {
      this.currentPage = 1;
      this.getExpiryListSearch(2);
    },

    getExpiryListSearch() {
      if (localStorage.getItem("selectedClient") == 'undefined' || localStorage.getItem("selectedClient") =='') {
        this.ClientErr =this.$t('common.clientError');
        this.$alertify.error(this.$t('common.clientError'))
        this.totalPage = 0;
        return false;
      }
      if (localStorage.getItem("selectedWarehouse") == 'undefined' || localStorage.getItem("selectedWarehouse") =='') {
        this.WarehouseErr = this.$t('common.warehouseError');
        this.$alertify.error(this.$t('common.warehouseError'))
        this.totalPage = 0;
        return false;
      }

      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      this.searchFlag = true;
      this.show=false;
      this.download =true;
      this.limitExeed = false;

      if (this.fromdate == "" || this.fromdate == null) {
        var fromdate = '';
      } else {
        var fromdate = this.payloaddateFormat(this.fromdate) + ' 00:00:00'
      }

      if (this.todate == "" || this.todate == null) {
        var todate = '';
      } else {
        var todate = this.payloaddateFormat(this.todate) + ' 23:59:00';
      }
      this.show = false;
      this.download = true;
      this.isLoadingData = true;
      this.input = ({
        offset: (this.currentPage - 1) * 10,
        limit: this.pageLimit,
        warehouseid: localStorage.getItem("selectedWarehouse"),
        productid: this.productid,
        clientid: localStorage.getItem("selectedClient"),
        clientproductid: this.clientproductid,
        fromdate: fromdate,
        todate: todate,
        racktype: this.RackType,
        only_expired:this.only_expired
      })
      //console.log(this.input);return false;
      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'expiryReport',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          this.isLoading = false;
          this.isLoadingData = false;
          this.resultCount = 0;
          this.listExpiryData = [];
          this.listExpiryData = result.data.data;
          if (result.data.errorCode == 0) {
            this.resultCount = result.data.count;
          } else {
            this.resultCount = 0;
            this.totalRows = 0;
          }

          this.totalRows = result.data.count
          if (Number(this.totalRows) > Number(this.recordLimit)) {
           this.limitExeed = true
         }
          if (result.data.count == 0) {
            this.totalPage = 0
          } else {
            if (this.totalRows <= this.pageLimit) {
              this.totalPage = 1
            } else {
              this.totalPage = Math.ceil(this.totalRows / this.pageLimit);
            }
          }
        }, error => {
          console.error(error)
        })
    },
    //to get Sales Report list
    getExpiryDataCSV(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fromdate = '';
      var todate = '';
      var dataFilter = {};
      this.show = true;
      this.download = false;


      if (this.fromdate == "" || this.fromdate == null) {
        var fromdate = '';
      } else {
        var fromdate = this.payloaddateFormat(this.fromdate) + ' 00:00:00'
      }

      if (this.todate == "" || this.todate == null) {
        var todate = '';
      } else {
        var todate = this.payloaddateFormat(this.todate) + ' 23:59:00';
      }
      this.isLoading = true;
      this.input = ({
        warehouseid: localStorage.getItem("selectedWarehouse"),
        productid: this.productid,
        clientid: localStorage.getItem("selectedClient"),
        clientproductid: this.clientproductid,
        fromdate: fromdate,
        todate: todate,
        userid: this.userid,
        racktype: this.RackType,
        csvData: csvCheck,
        only_expired:this.only_expired

      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          dataFilter[k] = v;
        }
      })


      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getExpiryReportCsv',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data.data.length > 0) {
            this.csvFields = {
              'productid': this.$t('common.productId'),
              'clientproductid': this.$t('product.clientProductId'),
              'productname': this.$t('printProductDetails.productName'),
              'expirydate': this.$t('printProductDetails.expiryDate'),
              'rackid': this.$t('warehouseRacks.rackId'),
              'racktype': this.$t('pickPendingMoveOrder.table.columns.rackType'),
              'remaining_days': this.$t('printProductDetails.remaningDays'),
              'lotno': this.$t('reports.lotControl'),
              'productstock': this.$t('activities.totalStock'),
            };
            var dateFilter = ['expirydate'];
            var skipFilter = [];
            this.listExpiryDataCsv = result.data.data;
            csvHelper.data.jsonToCSV(this.$t('editedjson.productExpiryReport'), this.listExpiryDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);
            this.isLoading = false;
          } else {
            if (result.data.status == true) {
              this.isLoading = false;
              this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
            } else {
              this.$alertify.error(result.data.msg.message);
            }
          }

        }, error => {
          console.error(error)
        })

    },
    getExpiryDataForXls(csvCheck = 0) {
      var userToken = window.localStorage.getItem('userToken')
      var myStr = userToken.replace(/"/g, '');
      var fromdate = '';
      var todate = '';
      this.show = true;
      this.download = false;
      this.dataFilter2 = [];
      var value = '';
      var str = '';
      if (this.fromdate == "" || this.fromdate == null) {
        var fromdate = '';
      } else {
        var fromdate = this.payloaddateFormat(this.fromdate) + ' 00:00:00'
      }

      if (this.todate == "" || this.todate == null) {
        var todate = '';
      } else {
        var todate = this.payloaddateFormat(this.todate) + ' 23:59:00';
      }

      this.input = ({
        warehouseid: localStorage.getItem("selectedWarehouse"),
        productid: this.productid,
        clientid: localStorage.getItem("selectedClient"),
        clientproductid: this.clientproductid,
        fromdate: fromdate,
        todate: todate,
        userid: this.userid,
        racktype: this.RackType,
        csvData: csvCheck,
        only_expired:this.only_expired

      })
      Object.entries(this.input).forEach(([k, v]) => {
        let skipkeys = ['offset', 'limit', 'csvData'];
        if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
          value += k + ':' + v + ','
          this.dataFilter2 = str.concat(value);

        }
      })


      axios({
          method: 'POST',
          'url': apiUrl.api_url + 'getExpiryReportCsv',
          'data': this.input,
          headers: {
            'Authorization': 'Bearer ' + myStr
          }
        })
        .then(result => {
          if (result.data.data.length > 0) {
            this.listReportDataforxls = [];
            this.csvFieldsForXls =[];
            this.csvFieldsForXls[this.$t('product.productId')] = 'productid',
            this.csvFieldsForXls[this.$t('product.clientProductId')] =  'clientproductid',
            this.csvFieldsForXls[this.$t('product.productName')] = 'productname',
            this.csvFieldsForXls[this.$t('printProductDetails.expiryDate')] ='expirydate',
            this.csvFieldsForXls[this.$t('warehouseRacks.rackId')] ='rackid',
            this.csvFieldsForXls[this.$t('pickPendingMoveOrder.table.columns.rackType')] = 'racktype',
            this.csvFieldsForXls[this.$t('printProductDetails.remaningDays')] = 'remaining_days',
            this.csvFieldsForXls[this.$t('reports.lotControl')] ='lotno',
            this.csvFieldsForXls[this.$t('activities.totalStock')] ='productstock',

            this.listReportDataforxls = result.data.data;
          } else {
            if (result.data.status == true) {
              this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
            } else {
              this.$alertify.error(result.data.msg.message);
            }
          }


        }, error => {
          console.error(error)
        })

    },
    //to reset search form
    resetFlt() {
      this.show = false;
      this.download = true;
      this.searchFlag = false;
      this.listExpiryData = []
      this.listExpiryDataCsv = []
      this.totalPage = 0;
      this.pageno = 0;
      this.totalRows = 0;
      this.resultCount = 0;
      this.fromdate = '';
      this.todate = '';
      this.ClientErr = '';
      this.productid = '';
      this.RackType = '';
      this.clientproductid = '';
      this.days = '';
      this.WarehouseErr = '';
      this.hideSelectDays=false
      this.only_expired=false
      // if (this.user_type == 'warehouse_user') {
      //   this.client = '';
      //   this.clientid = ''
      // } else if (this.user_type == 'client_user') {
      //   this.warehouse = '';
      //   this.warehouseid = ''
      // } else {
      //   this.client = '';
      //   this.clientid = ''
      //   this.warehouse = '';
      //   this.warehouseid
      // }

    },


    //to get pagination
    // getPaginationData(currentPage) {
    //   this.pageno = (currentPage - 1) * this.pageLimit;
    //   this.getExpiryListSearch();
    // },
    onPageChange(page) {
      this.currentPage = page;
      this.getExpiryListSearch()
    },
    //validate all form fields on onsubmit()
    onSubmit: function() {
      this.$validator.validateAll().then(() => {
        console.log('form is valid')
      }).catch(() => {
        console.log('errors exist')
      });
    },

  }
}



// WEBPACK FOOTER //
// ./src/views/components/reports/expiryreport/expiryreport.component.js